import React from 'react';
import { cn } from '../../lib/utils';

const variants = {
  primary:
    'bg-white text-black hover:bg-zinc-200 shadow-inner_glow',
  emerald:
    'bg-emerald text-black hover:brightness-110 shadow-inner_glow',
  outline:
    'bg-transparent text-white border border-white/15 hover:border-white/40 hover:bg-white/5',
  ghost: 'bg-transparent text-zinc-300 hover:bg-white/5 hover:text-white',
  danger: 'bg-red-500/90 text-white hover:bg-red-500',
};

const sizes = {
  sm: 'h-9 px-4 text-sm',
  md: 'h-11 px-5 text-sm',
  lg: 'h-12 px-7 text-base',
};

export function Button({
  variant = 'primary',
  size = 'md',
  pill = false,
  className,
  children,
  ...props
}) {
  return (
    <button
      className={cn(
        'inline-flex items-center justify-center gap-2 font-medium transition-[background-color,border-color,transform,filter] duration-200 hover:-translate-y-[1px] active:translate-y-0 disabled:opacity-50 disabled:pointer-events-none focus-ring',
        pill ? 'rounded-full' : 'rounded-xl',
        variants[variant],
        sizes[size],
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
